import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Template_3.css";
import Template_3_Header from "./Template_3_Header";
import Template_3_HeroSection from "./Template_3_HeroSection";
import Template_3_TravelTypes from "./Template_3_TravelTypes";
import Template_3_Destinations from "./Template_3_Destinations";
import Template_3_Packages from "./Template_3_Packages";
import Template_3_Reviews from "./Template_3_Reviews";
import Template_3_AboutUs from "./Template_3_AboutUs";
import Template_3_Footer from "./Template_3_Footer";
import Template_3_EnquiryPopup from "./Template_3_EnquiryPopup";
import Template_3_TopHeader from "./Template_3_TopHeader";
import Template_3_MainHeroSection from "./Template_3_MainHeroSection";

const Template_3_HomePage = () => {
  const [showEnquiryPopup, setShowEnquiryPopup] = useState(false);
  const [enquiryPackage, setEnquiryPackage] = useState(null);

  const handleEnquireClick = (pkg) => {
    setEnquiryPackage(pkg);
    setShowEnquiryPopup(true);
  };

  const handleCloseEnquiry = () => {
    setShowEnquiryPopup(false);
    setEnquiryPackage(null);
  };

  return (
    <div className="Template_3 homepage">
      <Template_3_TopHeader />
      <Template_3_Header />
      <Template_3_MainHeroSection />
      <Template_3_HeroSection />
      <Template_3_Packages onEnquireClick={handleEnquireClick} />
      <Template_3_TravelTypes />
      <Template_3_Destinations />
      <Template_3_Reviews />
      <Template_3_AboutUs />
      <Template_3_Footer />

      {showEnquiryPopup && enquiryPackage && (
        <Template_3_EnquiryPopup
          packageDetails={enquiryPackage}
          onClose={handleCloseEnquiry}
        />
      )}
    </div>
  );
};

export default Template_3_HomePage;
